// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"HW-z","inlineTitle":"IW-z","sponsoredAdsWrapper":"JW-z","marketplaceRecosWrapper":"KW-z"};